import { render, staticRenderFns } from "./moreOEAW.vue?vue&type=template&id=12b66ac0&lang=pug&"
import script from "./moreOEAW.vue?vue&type=script&lang=js&"
export * from "./moreOEAW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports